import React, {  useEffect, useState  } from "react";
import Notification_list from './create_list_notifiche_e_like';


export default function Chat_desktop(props) {
	

	useEffect(() => {  

		//ReactGA.pageview('/lista_chat', "Lista chat");
   },[]);
	
	return (
		<div className="container padding_bottom filters-padding">
			<div className="row">
			
				
				
					{/*  ----- QUI ANDRO' AD INSERIRE I MATCH -----*/}
			
					<Notification_list/>
			
			
			</div>
		
	</div>
	);
	
	
}